/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetCustomerResponseJson } from './get-customer-response-json';
import { GetCustomerResult } from '../results/get-customer-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { CustomerCompanyDto } from '../models/customer-company-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetCustomerResponse extends ResponseWithErrorGeneric<GetCustomerResponseJson, GetCustomerResult> implements IResponseWithErrorGeneric<GetCustomerResult> {
  public customerCompany: CustomerCompanyDto;

  //<custom-body>
  constructor(response: HttpResponse<GetCustomerResponse>) {
    super(response, GetCustomerResult.Error);

    if (this.result !== GetCustomerResult.Success) {
      return;
    }

    if (this.body.customerCompany != null) {
      this.customerCompany = new CustomerCompanyDto(this.body.customerCompany);
    }
  }
  //</custom-body>
}
